const chatResponsible = {
    title: 'Внимание!',
    description: `На чат <b>уже назначен</b> пользователь. Всё&nbsp;равно взять данный чат в работу?`,
    buttonText: 'Взять в работу',
} as const;

export default chatResponsible;
